import React from "react";
import { Text } from "../../atoms/Text/Text";
import { ScoreGroupedByUserModel } from "../../models/FriendModel";
import { User } from "../../models/User";
import { FriendTabs } from "../../services/Friend/FriendService";
import ScoreService from "../../services/RemoteScoreService";
import classNames from "classnames";

import styles from "./FriendContainer.css";

type RenderRowsOrderByFriendProps = {
  list: any;
  isOpened: boolean;
  tabId: FriendTabs;
  user: User;
};

export class RenderRowsOrderByFriend extends React.Component<RenderRowsOrderByFriendProps> {
  renderRow(list) {
    return list.slice(0, 10).map((user, ind) => (
      <React.Fragment key={ind}>
        <tr>
          <td>
            <UserName>
              {new Date(user.date).toLocaleString("en-US", {
                month: "long",
                day: "2-digit",
                weekday: "long",
              })}
            </UserName>
          </td>
          <td align="right">
            <UserScore>{ScoreService.formatScore(user.score)} PTS</UserScore>
          </td>
        </tr>
      </React.Fragment>
    ));
  }

  renderRows() {
    const { user, list } = this.props;

    return list.slice(0, 14).map((record: ScoreGroupedByUserModel, ind) => (
      <table className={styles.scores_table}>
        <thead>
          <tr>
            <th colSpan={2}>
              <div
                className={classNames({
                  [styles.userNameYou]: record.userId === user.id,
                })}
              >
                {record.userName}
              </div>
            </th>
          </tr>
        </thead>
        {record.scores[0].score != 0 && (
          <tbody>{this.renderRow(record.scores)}</tbody>
        )}
      </table>
    ));
  }

  render() {
    const { tabId, isOpened } = this.props;

    return (
      <div
        role="tabpanel"
        className={classNames({
          [styles.hiddenFriendTable]: !isOpened,
        })}
        id={tabId}
        aria-labelledby={`tab${tabId}`}
      >
        {this.renderRows()}
      </div>
    );
  }
}

const UserScore = (props: any) => (
  <Text className={styles.userScore} {...props} />
);
const UserName = (props: { you?: boolean; [key: string]: any }) => (
  <Text
    className={classNames(styles.userName, { [styles.userNameYou]: props.you })}
    {...props}
  />
);
